/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchPropertyLgaOptionsDto } from '../../models/search-property-lga-options-dto';

export interface SearchForPropertyByLgaOptions$Params {}

export function searchForPropertyByLgaOptions(
  http: HttpClient,
  rootUrl: string,
  params?: SearchForPropertyByLgaOptions$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchPropertyLgaOptionsDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForPropertyByLgaOptions.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchPropertyLgaOptionsDto>;
      }),
    );
}

searchForPropertyByLgaOptions.PATH = '/search/property/lga_options';
